import { CountryISOCodeField } from "components/fields/CountryISOCodeField";
import { DateFormatField } from "components/fields/DateFormatField";
import { TextEditableField } from "components/fields/EditableField";
import { FakeReferenceTextField } from "components/fields/FakeReferenceTextField";
import { LabelSourceField } from "components/fields/LabelSourceField";
import { LongTextField } from "components/fields/LongTextField";
import { SelectTextField } from "components/fields/SelectTextField";
import { YesNoField } from "components/fields/YesNoField";
import { FlexBlockRow } from "components/FlexShowLayout";
import { HideableOrderField } from "entities/HideableOrderField";
import React from "react";
import { ReferenceField, TextField } from "react-admin";

import { OrderService } from "../../../../entities";

export const ETDShowSection = (props) => {
	const {
		isNot3rdPartyRole,
		isOSFCManager,
		formatDriverLabel,
		TransDriverFieldWrapper,
		isFieldHidden = () => false,
		record,
		usesStorageModule,
	} = props;
	const isIntoPlukkStorage = record?.service === OrderService.intoPlukkStorage;
	const placeField = usesStorageModule ? "storage_place_id" : "area_id";
	const placeNameField = usesStorageModule ? "storage_place_name" : "area_name";

	return [
		<FlexBlockRow>
			<DateFormatField source="etd_date" />
			<TextField source="etd_time" />
			<TextField source="etd_slot_time" />
		</FlexBlockRow>,
		<FlexBlockRow>
			{!isFieldHidden(HideableOrderField.PLACE_TO) && <LongTextField source="place_to" />}
			{!isFieldHidden(HideableOrderField.PLACE_TO_COUNTRY_CODE) && (
				<CountryISOCodeField source="place_to_country_code" />
			)}
			<TextEditableField editable={isOSFCManager} source="port_out" />
			<ReferenceField source="optimal_port_out" reference="ports" link={false}>
				<TextField source="name" />
			</ReferenceField>
			{!isFieldHidden("etd_external_terminal_id") && (
				<ReferenceField
					source="etd_external_terminal_id"
					reference="external-terminal-links"
					link={false}
				>
					<TextField source="external_name" />
				</ReferenceField>
			)}
		</FlexBlockRow>,
		<FlexBlockRow>
			{!isFieldHidden(HideableOrderField.ETD_TRUCK) && (
				<SelectTextField source="etd_truck" refSource="etd_truck_id" reference="trucks" />
			)}
			{!isFieldHidden(HideableOrderField.ETD_DRIVER) &&
				(isNot3rdPartyRole ? (
					<SelectTextField
						source="etd_driver"
						refSource="etd_driver_id"
						reference="drivers"
						formatLabel={formatDriverLabel}
					/>
				) : (
					<TransDriverFieldWrapper source="etd_driver" prefix="etd" addLabel />
				))}
			{!isFieldHidden(HideableOrderField.ETD_DRIVER_PHONE) && (
				<TextField source="etd_driver_phone" />
			)}
		</FlexBlockRow>,
		<FlexBlockRow justify="flex-start">
			{isNot3rdPartyRole && !isFieldHidden(HideableOrderField.ETD_SHOW_DOC_FOR_TRANS) ? (
				<YesNoField source="etd_show_doc_for_trans" label="resources.orders.fields.etd_show_doc" />
			) : null}
			{isNot3rdPartyRole ? (
				<YesNoField
					source="is_etd_3rd_party_reload"
					label="resources.orders.fields.is_etd_3rd_party_reload"
				/>
			) : null}
			{!isFieldHidden(HideableOrderField.OUTGOING_TRIP_NUMBER) && (
				<TextField source="outgoing_trip_number" />
			)}
			{!isFieldHidden(HideableOrderField.LOADING_SEQUENCE) && (
				<TextField source="loading_sequence" />
			)}
		</FlexBlockRow>,
		<FlexBlockRow>
			{!isFieldHidden(HideableOrderField.IS_DOC_FOR_NFSA) && (
				<YesNoField source="is_doc_for_nfsa" />
			)}
			{isIntoPlukkStorage ? (
				<FakeReferenceTextField
					sortable={false}
					source={placeField}
					replaceSource={placeNameField}
				/>
			) : null}
			{isIntoPlukkStorage && !usesStorageModule && !isFieldHidden(HideableOrderField.IS_AREA_BLOCKED) ? (
				<YesNoField source="is_area_blocked" />
			) : null}
			{isIntoPlukkStorage && !isFieldHidden(HideableOrderField.LABEL_SOURCE) ? (
				<LabelSourceField source="label_source" record={record} />
			) : null}
			{isIntoPlukkStorage && !isFieldHidden(HideableOrderField.LABEL) ? (
				<TextField source="label" />
			) : null}
		</FlexBlockRow>,
	];
};
